module.exports = __webpack_public_path__ + "img/img-6mobile.0d28a0d1.png";